module.exports = __webpack_public_path__ + "static/img/avatar.64534079.png";